var service = function($filter) {
  var salesRepVacationMessage = function(repVacation) {
    var repName = repVacation.name || repVacation.contact_email;
    var message = repName + " is currently out of office";
    if (repVacation.end_time) {
      var endDate = $filter('date')(repVacation.end_time, 'longDate');
      message += " until " + endDate;
    }
    var coveringRepName = repVacation.covering_sales_rep.name || repVacation.covering_sales_rep.contact_email;
    message += ". " + coveringRepName + " will be managing their orders until they return.";
    return message;
  };

  var repEmails = function(reps) {
    return _.map(reps, function(r) {
      return r.contact_email;
    }).join(', ');
  };

  return {
    salesRepVacationMessage: salesRepVacationMessage,
    repEmails: repEmails
  };
};

service.$inject = ['$filter'];

tiz.service('SalesRep', service);
